import { css } from 'src/ui/style/css'
import { Theme } from 'src/ui/style/Theme'

export const createSystemBannerStyle = (th: Theme) => css`
    .sb-overlay {
        position: fixed;
        inset: 0;
        z-index: 2147483647;
        display: grid;
        justify-items: center;
        align-items: center;

        padding: var(--safe-area-top) var(--safe-area-right)
            var(--safe-area-bottom) var(--safe-area-left);

        min-height: 100dvh; /* iOS Safari */
        background: ${th.colors.blackWithOpacity};
        -webkit-backdrop-filter: saturate(120%) blur(2px);
        backdrop-filter: saturate(120%) blur(2px);
    }

    .sb-card {
        pointer-events: auto;
        width: min(92vw, 520px);
        max-width: 520px;
        border-radius: 16px;
        background: #101114; /* Consider adding to theme, e.g., th.colors.darkCharcoal */
        color: ${th.colors.white};
        box-shadow:
            0 8px 24px rgba(0, 0, 0, 0.3),
            0 0 0 1px rgba(255, 255, 255, 0.07) inset;
        padding: 16px 16px 12px;
        transform: translateY(0);
        transition:
            transform 160ms ease,
            opacity 160ms ease;
        opacity: 1;
    }

    .sb-idle-warning {
    }
    .sb-cleared {
    }
    .sb-error {
    }

    .sb-header {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 8px;
    }

    .sb-dot {
        width: 10px;
        height: 10px;
        border-radius: 999px;
        background: ${th.colors.secondary};
        box-shadow: 0 0 0 3px rgba(243, 208, 62, 0.15); /* th.colors.secondary with opacity */
    }
    .sb-error .sb-dot {
        background: ${th.colors.error};
        box-shadow: 0 0 0 3px rgba(144, 29, 29, 0.15); /* th.colors.error with opacity */
    }
    .sb-cleared .sb-dot {
        background: ${th.colors.okGreen};
        box-shadow: 0 0 0 3px rgba(120, 189, 112, 0.15); /* th.colors.okGreen with opacity */
    }

    .sb-title {
        margin: 0;
        font-size: 16px;
        font-weight: 700;
        line-height: 1.2;
    }

    .sb-message {
        margin: 0 0 12px 0;
        font-size: 14px;
        line-height: 1.45;
        color: ${th.colors.lightGray};
    }

    .sb-actions {
        display: flex;
        gap: 8px;
        justify-content: flex-end;
    }

    .sb-btn {
        appearance: none;
        border: none;
        border-radius: 10px;
        padding: 10px 14px;
        font-size: 14px;
        line-height: 1;
        cursor: pointer;
    }

    .sb-btn-primary {
        background: ${th.colors.tertiary};
        color: ${th.colors.white};
    }
    .sb-btn-primary:active {
        transform: translateY(1px);
    }

    .sb-btn-ghost {
        background: transparent;
        color: #cdd3db; /* Consider adding to theme */
        outline: 1px solid rgba(255, 255, 255, 0.16);
    }
    .sb-btn-ghost:active {
        transform: translateY(1px);
    }

    @media (min-width: 769px) {
        .sb-overlay {
            background: transparent;
            -webkit-backdrop-filter: none;
            backdrop-filter: none;
            pointer-events: none;
            justify-items: end;
            align-items: end;
            padding: 24px;
        }
        .sb-card {
            pointer-events: auto;
            width: min(420px, 92vw);
        }
    }

    @media (prefers-reduced-motion: reduce) {
        .sb-card {
            transition: none;
        }
    }
`
